import React from "react";
import "./LoaderNew.css";

const LoaderNew = () => {
  return (
    <div>
      <div className="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default LoaderNew;
